import React, { type FC } from 'react';
import { Button, Text, Space } from '@g2u/ui-kit';
import { observer } from 'mobx-react-lite';

import { JobServiceTypeLabel, JsonDataItem, type WithOptionalDataTest } from 'types';
import { Details, Section } from 'components';
import { BookingStore } from 'store';

export namespace ReviewDetails {
  export type Props = {
    onEdit: () => void;
    onConfirm: () => void;
  } & WithOptionalDataTest;

  export const $: FC<Props> = observer((props) => {
    const { onEdit, onConfirm } = props;
    const { serviceSelection, job } = BookingStore;

    return (
      <Section.$ title="Confirmation">
        <Space.$ size={Space.Size.Large} direction={Space.Direction.Vertical}>
          <Text.$>Do you need to update anything below?</Text.$>
          <Space.$ size={Space.Size.ExtraSmall} wrap align={Space.Align.Start} direction={Space.Direction.Vertical}>
            <Details.$ columns size={Details.Size.Full}>
              <Details.Item
                label={'Service Type :'}
                value={
                  JobServiceTypeLabel[
                    serviceSelection?.service_attributes?.job_service_type as keyof typeof JobServiceTypeLabel
                  ]
                }
              />
              <Details.Item
                label={'Device(s) :'}
                value={serviceSelection?.service_selection.device_types?.join(',') || 'Unknown'}
              />
              <Details.Item
                label={'Operating System :'}
                value={serviceSelection?.service_selection.os?.join(',') || 'Unknown'}
              />
              <Details.Item
                label={'Service(s) :'}
                value={job?.products?.map((product: JsonDataItem) => product.product.name).join(',')}
              />
            </Details.$>
          </Space.$>
          <Space.$>
            <Button.$ dataTestId={'confirm-details-btn'} onClick={onConfirm} style={{ width: 100 }}>
              No
            </Button.$>
            <Button.$
              dataTestId={'change-details-btn'}
              onClick={onEdit}
              style={{ width: 100 }}
              type={Button.Type.Primary}
            >
              Yes
            </Button.$>
          </Space.$>
        </Space.$>
      </Section.$>
    );
  });
}
